import {useQuery} from "@apollo/client";
import {useEffect, useState} from "react";

import {QUERY_ALL_PERFORMERS} from "../queries/GraphQLQueries";

export default function usePerformerData() {

    const {loading: isPerformerDataLoading, error: performerDataLoadingError, data} = useQuery(QUERY_ALL_PERFORMERS);

    const [performerData, setPerformerData] = useState([]);

    useEffect(() => {
        if (data?.users_filtered) {

            const performers = [...data.users_filtered];
            performers
                .sort((a, b) => a.displayName.localeCompare(b.displayName));

            setPerformerData(performers);
        }
    }, [data]);

    return {
        isPerformerDataLoading,
        performerDataLoadingError,
        performerData
    };
}